export default __webpack_public_path__ + "static/media/img12.cb524bf3.png";